import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { FormGroup, FormLabel, FormControl } from "react-bootstrap";
import "./ShiftExchangeCreateModal.scss";
import { FiCalendar, FiRepeat } from "react-icons/fi";
import moment from "moment";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
registerLocale("es", es);
import SubmitButton from "components/SubmitButton";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";
import { errorFormating } from "utils/utils";
import { plansService, employeesService } from "services";
import {
	planAssignmentExchangesService,
	exchangeStatus,
} from "services/planAssignmentExchangesService";

class ShiftExchangeCreateModal extends React.Component {
	constructor(props) {
		super(props);
		const { exchange } = props;
		const requesterPlan = exchange?.requester_plan?.assignments?.[0] || null;
		const targetPlan = exchange?.target_plan?.assignments?.[0] || null;
		this.state = {
			requesterDate: exchange?.requester_plan?.day
				? moment(exchange.requester_plan.day).toDate()
				: null,
			requesterPlans: requesterPlan ? [requesterPlan] : [],
			requesterPlan,
			requesterPlanLoading: false,
			requesterPlanError: false,
			targetEmployeeId: exchange?.target_employee?.id
				? String(exchange.target_employee.id)
				: "",
			targetEmployee: exchange?.target_employee || null,
			targetDate: exchange?.target_plan?.day
				? moment(exchange.target_plan.day).toDate()
				: null,
			targetPlans: targetPlan ? [targetPlan] : [],
			targetPlan,
			targetPlanLoading: false,
			targetPlanError: false,
			comments: exchange?.comments || "",
			isLoading: false,
			submitted: false,
			errors: {},
		};
	}

	async componentDidMount() {
		if (this.props.disabled) return;
		const { user } = this.props;
		const groupId = user?.employee_with_group?.group?.id;
		if (!groupId) return;
		try {
			const res = await employeesService.getSelectable({
				enabled: true,
				group_id: groupId,
				page: 0,
				page_size: 40,
			});
			if (!res.ok) return;
			const others = (res.data || []).filter(
				(e) => String(e.id) !== String(user.id)
			);
			if (!this.props.exchange && others.length === 1) {
				this.setState({
					targetEmployeeId: String(others[0].id),
					targetEmployee: others[0],
				});
			}
		} catch {}
	}

	async fetchPlans(employeeId, date) {
		const formatted = moment(date).format("YYYY-MM-DD");
		const groupId = this.props.user?.employee_with_group?.group?.id;
		const response = await plansService.getPlanAssignments({
			employee_id: employeeId,
			group_id: groupId,
			start: formatted,
			end: formatted,
		});

		console.log("[fetchPlans] employeeId:", employeeId, "response:", response);
		const employees = response.data || (Array.isArray(response) ? response : []);
		const assignments = [];
		employees.forEach((emp) => {
			const empId = emp.employee?.id ?? employeeId;
			if (String(empId) !== String(employeeId)) return;
			(emp.plans || []).forEach((plan) => {
				(plan.assignments || []).forEach((assignment) => {
					if (assignment.shift) assignments.push(assignment);
				});
			});
		});
		return assignments;
	}

	handleRequesterDateChange = async (date) => {
		this.setState({
			requesterDate: date,
			requesterPlans: [],
			requesterPlan: null,
			requesterPlanError: false,
			requesterPlanLoading: !!date,
		});
		if (!date) return;
		try {
			const plans = await this.fetchPlans(this.props.user.id, date);
			this.setState({
				requesterPlans: plans,
				requesterPlan: plans.length === 1 ? plans[0] : null,
				requesterPlanLoading: false,
				requesterPlanError: plans.length === 0,
			});
		} catch {
			this.setState({ requesterPlanLoading: false, requesterPlanError: true });
		}
	};

	handleTargetEmployeeChange = async (id) => {
		this.setState({
			targetEmployeeId: id || "",
			targetPlans: [],
			targetPlan: null,
			targetPlanError: false,
		});
		if (id && this.state.targetDate) {
			await this.loadTargetPlans(id, this.state.targetDate);
		}
	};

	handleTargetDateChange = async (date) => {
		this.setState({
			targetDate: date,
			targetPlans: [],
			targetPlan: null,
			targetPlanError: false,
			targetPlanLoading: !!date && !!this.state.targetEmployeeId,
		});
		if (!date || !this.state.targetEmployeeId) return;
		await this.loadTargetPlans(this.state.targetEmployeeId, date);
	};

	async loadTargetPlans(employeeId, date) {
		this.setState({ targetPlanLoading: true, targetPlanError: false });
		try {
			const plans = await this.fetchPlans(employeeId, date);
			this.setState({
				targetPlans: plans,
				targetPlan: plans.length === 1 ? plans[0] : null,
				targetPlanLoading: false,
				targetPlanError: plans.length === 0,
			});
		} catch {
			this.setState({ targetPlanLoading: false, targetPlanError: true });
		}
	}

	handleCommentsChange = (event) => {
		this.setState({ comments: event.target.value });
	};

	validate() {
		const { requesterPlan, targetPlan } = this.state;
		const errors = {};
		if (!requesterPlan) errors.requesterPlan = this.props.t("shiftExchanges.modal.errorNoRequesterPlan");
		if (!targetPlan) errors.targetPlan = this.props.t("shiftExchanges.modal.errorNoTargetPlan");
		if (requesterPlan && targetPlan && requesterPlan.id === targetPlan.id) {
			errors.targetPlan = this.props.t("shiftExchanges.modal.errorSamePlan");
		}
		return errors;
	}

	handleSubmit = async (event) => {
		event.preventDefault();
		this.setState({ submitted: true });

		const errors = this.validate();
		if (Object.keys(errors).length > 0) {
			this.setState({ errors });
			return;
		}

		this.setState({ isLoading: true, errors: {} });

		const { requesterPlan, targetPlan, comments } = this.state;

		const exchangePayload = {
			comments,
			requester_plan_id: requesterPlan.id,
			target_plan_id: targetPlan.id,
			status: exchangeStatus.pending,
		};
		const response = this.props.exchange
			? await planAssignmentExchangesService.update({
				...exchangePayload,
				id: this.props.exchange.id,
				version: this.props.exchange.version,
			})
			: await planAssignmentExchangesService.add(exchangePayload);

		if (response.ok) {
			toastr.success(
				this.props.t("common.success"),
				this.props.t("common.changesSaved")
			);
			this.setState({ isLoading: false });
			this.props.handleClose();
			this.props.reloadExchanges();
		} else {
			const errorMsg = errorFormating(response);
			this.setState({ isLoading: false, errors: errorMsg });
		}
	};

	getShiftOptions(plans, selectedPlan, onSelect) {
		const { t } = this.props;
		if (plans.length === 0) return null;
		return (
			<div className="exchange-shift-options">
				{plans.map((plan) => {
					const isSelected = selectedPlan?.id === plan.id;
					return (
						<button
							key={plan.id}
							type="button"
							className={`exchange-shift-option ${isSelected ? "exchange-shift-option--selected" : ""}`}
							style={{
								backgroundColor: plan.shift?.background_color || undefined,
								borderColor: isSelected
									? undefined
									: plan.shift?.border_color || undefined,
							}}
							onClick={() => onSelect(plan)}
						>
							{plan.shift?.name || t("common.unknown")}
						</button>
					);
				})}
			</div>
		);
	}

	render() {
		const { t, user } = this.props;
		const { disabled } = this.props;
		const groupId = user?.employee_with_group?.group?.id;
		const {
			requesterDate,
			requesterPlans,
			requesterPlan,
			requesterPlanLoading,
			requesterPlanError,
			targetEmployeeId,
			targetEmployee,
			targetDate,
			targetPlans,
			targetPlan,
			targetPlanLoading,
			targetPlanError,
			comments,
			errors,
			isLoading,
		} = this.state;

		const today = new Date();

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body shift-edit shift-exchange-create-modal">
					<div className="exchange-sides">
						<div className="exchange-side">
							<p className="exchange-section-label">
								{t("shiftExchanges.modal.yourShift")}
							</p>

							<FormGroup
								controlId="requesterDate"
								className={`form-group form-date ${!requesterDate && "empty"}`}
							>
								<FormLabel>
									{t("shiftExchanges.modal.date")}{" "}
									<span className="label-required">*</span>
								</FormLabel>
								<DatePicker
									disabled={disabled}
									selected={requesterDate}
									onChange={this.handleRequesterDateChange}
									className="form-control"
									dateFormat="dd/MM/yyyy"
									locale="es"
									placeholderText="dd/mm/aaaa"
									minDate={today}
								/>
								<FiCalendar />
							</FormGroup>

							{requesterPlanLoading && (
								<span className="text-muted exchange-plan-loading">{t("common.loading")}...</span>
							)}
							{!requesterPlanLoading && requesterDate && requesterPlanError && (
								<span className="text-danger exchange-plan-empty">
									{t("shiftExchanges.modal.noShiftOnDate")}
								</span>
							)}
							{!requesterPlanLoading && this.getShiftOptions(
								requesterPlans,
								requesterPlan,
								(plan) => this.setState({ requesterPlan: plan, errors: { ...this.state.errors, requesterPlan: undefined } })
							)}
							{errors.requesterPlan && (
								<div className="invalid-feedback d-block">{errors.requesterPlan}</div>
							)}
						</div>

						<div className="exchange-divider">
							<FiRepeat />
						</div>

						<div className="exchange-side">
							<p className="exchange-section-label">
								{t("shiftExchanges.modal.targetShift")}
							</p>

							<FormGroup className="form-group" controlId="targetEmployeeId">
								<FormLabel>
									{t("shiftExchanges.modal.employee")}{" "}
									<span className="label-required">*</span>
								</FormLabel>
								<EmployeeSelectSearch
									disabled={disabled}
									value={targetEmployeeId || null}
									onChange={this.handleTargetEmployeeChange}
									allowClear={false}
									fetchOptions={{ enabled: true, group_id: groupId }}
									excludeIds={[String(user.id)]}
									knownEmployee={targetEmployee}
									placeholder={t("common.searchEmployee")}
									controlId="targetEmployeeId"
								/>
							</FormGroup>

							<FormGroup
								controlId="targetDate"
								className={`form-group form-date ${!targetDate && "empty"}`}
							>
								<FormLabel>
									{t("shiftExchanges.modal.date")}{" "}
									<span className="label-required">*</span>
								</FormLabel>
								<DatePicker
									disabled={disabled}
									selected={targetDate}
									onChange={this.handleTargetDateChange}
									className="form-control"
									dateFormat="dd/MM/yyyy"
									locale="es"
									placeholderText="dd/mm/aaaa"
									minDate={today}
								/>
								<FiCalendar />
							</FormGroup>

							{targetPlanLoading && (
								<span className="text-muted exchange-plan-loading">{t("common.loading")}...</span>
							)}
							{!targetPlanLoading && targetDate && targetEmployeeId && targetPlanError && (
								<span className="text-danger exchange-plan-empty">
									{t("shiftExchanges.modal.noShiftOnDate")}
								</span>
							)}
							{!targetPlanLoading && this.getShiftOptions(
								targetPlans,
								targetPlan,
								(plan) => this.setState({ targetPlan: plan, errors: { ...this.state.errors, targetPlan: undefined } })
							)}
							{errors.targetPlan && (
								<div className="invalid-feedback d-block">{errors.targetPlan}</div>
							)}
						</div>
					</div>

					<FormGroup className="form-group mt25" controlId="comments">
						<FormLabel>{t("shiftExchanges.modal.comments")}</FormLabel>
						<FormControl
							as="textarea"
							disabled={disabled}
							value={comments}
							onChange={this.handleCommentsChange}
							placeholder={t("shiftExchanges.modal.commentsPlaceholder")}
						/>
					</FormGroup>

					{errors.general && (
						<div className="alert alert-danger alert-general-error fade show" role="alert">
							{errors.general}
						</div>
					)}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{disabled ? t("common.close") : t("common.cancel")}
					</button>
					{!disabled && (
						<SubmitButton
							type="submit"
							isLoading={isLoading}
							text={t("common.save")}
							loadingText={t("common.saving")}
						/>
					)}
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => ({
	user: reducers.authReducer.user,
});

export default connect(mapStateToProps, null)(withTranslation()(ShiftExchangeCreateModal));
